import { InMemoryOriginsRepository } from "../../../../../test/repositories/inMemoryOriginsRepository"
import { makeOrigin } from "../../../../../test/factories/makeOrigin"
import { IFetchOriginsProtocol } from "../../protocols/origin/IFetchOriginsProtocol"
import { FetchOriginsUseCase } from "./fetchOrigins"

let sut: IFetchOriginsProtocol
let repository: InMemoryOriginsRepository

describe('Fetch Origins', () => {
  beforeEach(() => {
    repository = new InMemoryOriginsRepository()
    sut = new FetchOriginsUseCase(repository)
  })
  it('Should be able to create a new origin', async () => {
    const origin1OnDatabase = makeOrigin({
      name: `Test Origin 1`
    })
   const origin2OnDatabase = makeOrigin({
    name: `Test Origin 1`
    })
    const origin3OnDatabase = makeOrigin({
      name: `Test Origin 1`
    })

    await Promise.all([
      repository.create(origin1OnDatabase),
      repository.create(origin2OnDatabase),
      repository.create(origin3OnDatabase),
    ])

    const { origins } = await sut.execute({})

    expect(origins.length).toEqual(3)
  })
})